import { GLOBAL_FOCUS, type Focus } from "@/workloads/focus";
import { GLOBAL_TABS } from "@/workloads/scope";

import { DetailShell } from "./DetailShell";
import { GlobalBank } from "./global/GlobalBank";
import { GlobalCapacity } from "./global/GlobalCapacity";
import { GlobalContainerRegistries } from "./global/GlobalContainerRegistries";
import { GlobalCost } from "./global/GlobalCost";
import { GlobalDashboard } from "./global/GlobalDashboard";
import { GlobalEgressIps } from "./global/GlobalEgressIps";
import { GlobalEvents } from "./global/GlobalEvents";
import { GlobalProviders } from "./global/GlobalProviders";
import { GlobalRollouts } from "./global/GlobalRollouts";
import { GlobalSettings } from "./global/GlobalSettings";

interface Props {
  tab: string;
  setFocusAndTab: (focus: Focus, tab: string) => void;
}

export function GlobalDetail({ tab, setFocusAndTab }: Props) {
  return (
    <DetailShell
      tabs={GLOBAL_TABS}
      activeTab={tab}
      onTabChange={(id) => setFocusAndTab(GLOBAL_FOCUS, id)}
      navTitle="BackStage"
      navSubtitle="all services"
      breadcrumb={[{ label: "BackStage" }]}
    >
      {renderTab(tab, setFocusAndTab)}
    </DetailShell>
  );
}

function renderTab(
  tab: string,
  setFocusAndTab: (focus: Focus, tab: string) => void,
) {
  switch (tab) {
    case "cost":
      return <GlobalCost />;
    case "capacity":
      return <GlobalCapacity />;
    case "bank":
      return <GlobalBank setFocusAndTab={setFocusAndTab} />;
    case "events":
      return <GlobalEvents />;
    case "rollouts":
      return <GlobalRollouts />;
    case "providers":
      return <GlobalProviders />;
    case "container-registries":
      return <GlobalContainerRegistries />;
    case "egress-ips":
      return <GlobalEgressIps />;
    case "settings":
      return <GlobalSettings />;
    case "dashboard":
    default:
      return <GlobalDashboard />;
  }
}
